import { render, staticRenderFns } from "./CardCatalog.vue?vue&type=template&id=232a4db3&"
import script from "./CardCatalog.vue?vue&type=script&lang=js&"
export * from "./CardCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports